var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordEyeIconSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20809_26590)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1137 9.58228C15.6208 12.2631 12.7898 13.9284 9.72674 13.9284C6.66174 13.9284 3.83069 12.2631 2.33783 9.58228C2.22286 9.37412 2.22286 9.15407 2.33783 8.94609C3.83069 6.26532 6.66174 4.60018 9.72674 4.60018C12.7898 4.60018 15.6208 6.26532 17.1137 8.94609C17.2307 9.15407 17.2307 9.37412 17.1137 9.58228ZM18.0673 8.41458C16.3821 5.38784 13.1863 3.50781 9.72674 3.50781C6.26522 3.50781 3.06938 5.38784 1.38421 8.41458C1.08287 8.95462 1.08287 9.57375 1.38421 10.1134C3.06938 13.1401 6.26522 15.0206 9.72674 15.0206C13.1863 15.0206 16.3821 13.1401 18.0673 10.1134C18.3686 9.57379 18.3686 8.95462 18.0673 8.41458ZM9.72674 11.5049C10.9619 11.5049 11.967 10.4998 11.967 9.26409C11.967 8.02839 10.9619 7.02325 9.72674 7.02325C8.48962 7.02325 7.48448 8.02839 7.48448 9.26409C7.48448 10.4998 8.48966 11.5049 9.72674 11.5049ZM9.72674 5.93088C7.88693 5.93088 6.39211 7.42631 6.39211 9.26413C6.39211 11.1024 7.88697 12.5972 9.72674 12.5972C11.5646 12.5972 13.0594 11.1023 13.0594 9.26413C13.0594 7.42631 11.5646 5.93088 9.72674 5.93088Z",
    fill: "#0F172A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20809_26590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5,
    height: 18.5,
    fill: "white",
    transform: "translate(0.475586 0.015625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeIconSmall);
export default __webpack_public_path__ + "static/media/PasswordEyeIconSmall.b4f16d11d0c845957cac687883e0007f.svg";
export { ForwardRef as ReactComponent };